module.exports = __webpack_public_path__ + "img/Timelapse.c987d8a9.svg";